import gql from 'graphql-tag';

export default gql`
  query GetGhdSocialNetwork($id: Int!) {
    getGhdSocialNetwork(id: $id) {
      id
      name
      url
      icon_light
      icon_dark
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/ghd-social-network/get.js